import _ from 'lodash';

const thirdPartyUtils = {

  getLandingPageFromName(name) {
    return thirdPartyLandingPages[name] ? thirdPartyLandingPages[name] : thirdPartyLandingPages.default;
  }

  // 1.13 - deprec, lives on server now
  , getACRPLoginPageLink(env) {
    // this is different for our different environments, and hard to generate anyway.
    switch(env) {
      case 'development':
        return `https://www.avectraacrp.com/eweb/DynamicPage.aspx?Site=ACRP&WebCode=LoginRequired&URL_Success=http%3A%2F%2Flocalhost%3A3030%2F%3Fprovider%3Dacrp%26authToken%3D%7Btoken%7D`
      case 'staging':
        return `https://www.avectraacrp.com/eweb/DynamicPage.aspx?Site=ACRP&WebCode=LoginRequired&URL_Success=https%3A%2F%2Fredstone.f-labs.co%2F%3Fprovider%3Dacrp%26authToken%3D%7Btoken%7D`
      case 'production':
        return `https://www.avectraacrp.com/eweb/DynamicPage.aspx?Site=ACRP&WebCode=LoginRequired&URL_Success=https%3A%2F%2Fapp.pro-ficiency.com%2F%3Fprovider%3Dacrp%26authToken%3D%7Btoken%7D`
      default: 
        return null;
    }

  }

}

const thirdPartyLandingPages = {

  // the 3rd party landing/login pages will be defined here
  // based on the url, we should return a json object describing what that particular
  // page should look like.  schema TBD based on the ui.
  // NOTE this ui still needs to updated to reflect this.
  default: {
    // default choice if none other matched
    helmet: 'Learning portal | Powered by Pro-ficiency'
    , portalName: 'Learning Portal'
  },
  'apoc': {
    helmet: `Abbott Point of Care | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Abbott Point of Care`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/abbott_color.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'advancedclinical': {
    helmet: `Advanced Clinical | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Advanced Clinical`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/advanced_clinical-color.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'baycare': {
    helmet: `BayCare | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `BayCare`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/baycare.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  // 'VCHRI_BCCRIN': {
  //   helmet: `Vancouver Coastal Health Research Institute | ACRP Learning`
  //   , portalName: 'Learning Portal'
  //   , sponsorName: `Vancouver Coastal Health Research Institute`
  //   , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/vchri_logo.png'
  //   , thirdPartyName: 'The Association of Clinical Research Professionals'
  //   , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  // },
  // // changed on request 3.14.22
  
  'CTBC': {
    helmet: `Clinical Trials BC | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Clinical Trials BC`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/MSHRBC_ClinicalTrialsBC_RGB.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'ChildrensNational': {
    helmet: `Children's National | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Children's National`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/childrensnational_logo.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'Clinipace': {
    helmet: `Clinipace | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Clinipace`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/clinipace_logo.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'cpakids': {
    helmet: `Coastal Pediatric Research | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Coastal Pediatric Research`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/coastal_color.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'TDN': {
    helmet: `Therapeutics Development Network | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Therapeutics Development Network`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/tdn_logo.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'fomat': {
    helmet: `FOMAT Medical Research | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `FOMAT Medical Research`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/fomat_logo.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'GUMC': {
    helmet: `Georgetown University Medical Center | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Georgetown University Medical Center`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/gumc_logo.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'hamiltonresearch': {
    helmet: `St. Joseph's Hamilton Health | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `St. Joseph's Hamilton Health`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/hamilton_logo.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'iacthealth': {
    helmet: `IACT Health | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `IACT Health`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/iact_serrg_logo.gif'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'kumcri': {
    helmet: `KU Medical Center Research Institute | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `University of Kansas Medical Center Research Institute`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/kumc_color.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'lurie-elearn': {
    helmet: `Lurie Children's Hospital | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Lurie Children's Hospital`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/lurie_color.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'RoivantDevelopmentForum': {
    helmet: `Roivant Development Forum | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Roivant Development Forum`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/metavant-logo.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'musc': {
    helmet: `South Carolina Clinical & Translational Research Institute | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `South Carolina Clinical & Translational Research Institute`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/musc_color.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'NAVREF': {
    helmet: `NAVREF | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `NAVREF`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/navref-logo.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'northwellclinicalresearch': {
    helmet: `Northwell Health | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Northwell Health`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/northwell_logo.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'NYULMC': {
    helmet: `NYU School of Medicine | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `NYU School of Medicine`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/nyu_color.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'pennstate': {
    helmet: `Penn State Hershey Medical Center | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Penn State Hershey Medical Center`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/pennstate_color.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'PPClinicalResearchNetwork': {
    helmet: `Planned Parenthood Research | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Planned Parenthood Research`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/ppfa_logo.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'RLS': {
    helmet: `Randstad Life Sciences | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Randstad Life Sciences`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/rurls.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'RocheMSA': {
    helmet: `Roche MSA | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Roche MSA`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/roche_color.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'rush': {
    helmet: `Rush University Medical Center | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Rush University Medical Center`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/rush_logo.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'sarahcannon': {
    helmet: `Sarah Cannon Research Institute | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Sarah Cannon Research Institute`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/sarahcannon_logo.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'SPARC': {
    helmet: `SignalPath Research Consortium | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `SignalPath Research Consortium`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/sparc-logo.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'scri': {
    helmet: `Southeastern Clinical Research Institute | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Southeastern Clinical Research Institute`
    , sponsorLogoUrl: 'http://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/secri_logo.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'SCCResearch': {
    helmet: `SouthWest Care | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `SouthWest Care`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/scc_research.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'spectrumhealth': {
    helmet: `Spectrum Health | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Spectrum Health`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/spectrum_logo.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'SynteractHCR': {
    helmet: `SynteractHCR Inc. | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `SynteractHCR Inc.`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/synteract_logo.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'ucdenver': {
    helmet: `University of Colorado Denver | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `University of Colorado Denver`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/cudenver_sl_clr.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'uc': {
    helmet: `UC Davis | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `UC Davis`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/ucdavis_color.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'usouthal': {
    helmet: `University of South Alabama | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `University of South Alabama`
    , sponsorLogoUrl: 'http://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/usa_color.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'uscchla': {
    helmet: `USC & Children's Hospital of Los Angeles | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `USC & Children's Hospital of Los Angeles`
    , sponsorLogoUrl: 'http://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/usc_childrens_logo.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'va': {
    helmet: `US Department of Veterans Affairs | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `US Department of Veterans Affairs`
    , sponsorLogoUrl: 'http://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/va_logo.png'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'xcovery': {
    helmet: `Xcovery Targeted Therapeutics | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `Xcovery Targeted Therapeutics`
    , sponsorLogoUrl: 'http://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/xcovery_logo.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  }, 

  'ValleyHealthSystem': {
    helmet: `ValleyHealth | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `ValleyHealth`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/valleyhealth.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'KPS': {
    helmet: `KPS Life | ACRP Learning`
    , portalName: 'Learning Portal'
    , sponsorName: `KPS Life`
    , sponsorLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/KPS_logo.jpg'
    , thirdPartyName: 'The Association of Clinical Research Professionals'
    , thirdPartyLogoUrl: 'https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png'
  },

  'CHP_CoCRP': {
    helmet: `Children’s Hospital of Pittsburgh | ACRP Learning`
    , portalName: `Learning Portal`
    , sponsorName: `Children’s Hospital of Pittsburgh`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/UPMC-childrens-hospital-logo.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'RBHS_Clinical_Research': {
    helmet: `Rutgers | ACRP Learning`
    , portalName: `Learning Portal`
    , sponsorName: `Rutgers`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/rutgers_logo.PNG`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },
  
  'Velocityclinical': {
    helmet: `Velocity Clinical Research | ACRP Learning`
    , portalName: `Learning Portal`
    , sponsorName: `Velocity Clinical Research`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/velocity_logo.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'elligo': {
    helmet: `Elligo | ACRP Learning`
    , portalName: `Learning Portal`
    , sponsorName: `Elligo`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/Elligo_LogoTagline_Screen.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'Adventhealthresearch': {
    helmet: `AdventHealth Research | ACRP Learning`
    , portalName: `Learning Portal`
    , sponsorName: `AdventHealth Research`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/AdventHealth-logo.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'merckcra': {
    helmet: `Merck CRA Core Competency Foundations | ACRP Learning`
    , portalName: `Learning Portal`
    , sponsorName: `Merck`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'javaracrc': {
    helmet: `Javara CRC Core Competency Foundations Subportal | ACRP Learning`
    , portalName: `Javara CRC Core Competency Foundations`
    , sponsorName: `Javara`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'Adventhealthresearchcrc': {
    helmet: `AdventHealth Research CRC Core Competency Foundations | ACRP Learning`
    , portalName: `AdventHealth Research CRC Core Competency Foundations`
    , sponsorName: `AdventHealth Research`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/AdventHealth-logo.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'curebase': {
    helmet: `Curebase | ACRP Learning`
    , portalName: `Curebase | ACRP Learning`
    , sponsorName: `Curebase`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/curebase-logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'CRI': {
    helmet: `CRI Training | ACRP Learning`
    , portalName: `CRI Training | ACRP Learning`
    , sponsorName: `CRI Training`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'ZS': {
    helmet: `ZS | ACRP Learning`
    , portalName: `ZS`
    , sponsorName: `ZS`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/ZS_LOGO_RGB.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'Averahealth': {
    helmet: `Avera Heath CRC Core Competency Foundations | ACRP Learning`
    , portalName: `Avera Heath CRC Core Competency Foundations `
    , sponsorName: `Avera Heath`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'protrials': {
    helmet: `ProTrials Training | ACRP Learning`
    , portalName: `ProTrials Training`
    , sponsorName: `ProTrials`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/PTR_HighRes_logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'ecommunity': {
    helmet: `Community Health Network | ACRP Learning`
    , portalName: `Community Health Network`
    , sponsorName: `Community Health Network`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/communityhealthnetwork_logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  },

  'circuitclinical': {
    helmet: `ACRP/Circuit Clinical GCP Training Portal | ACRP Learning`
    , portalName: `ACRP/Circuit Clinical GCP Training Portal`
    , sponsorName: `Community Health Network`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/Circuit_Logo.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'personalis': {
    helmet: `Personalis | ACRP Learning`
    , portalName: `Personalis Training`
    , sponsorName: `Personalis`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/PersonalisLogo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'MECC': {
    helmet: `ACRP/MECC Training | ACRP Learning`
    , portalName: `ACRP/MECC Training`
    , sponsorName: `MECC`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/MECC_logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'Ochsner': {
    helmet: `Ochsner Clinical Research | ACRP Learning`
    , portalName: `Ochsner Clinical Research`
    , sponsorName: `Ochsner Clinical Research`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/OchsnerHealth_Logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'bostonscientific': {
    helmet: `BSCI Research | ACRP Learning`
    , portalName: `BSCI Research`
    , sponsorName: `BSCI`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/BSC_Logo.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'Optina': {
    helmet: `ACRP/Optina Training Portal | ACRP Learning`
    , portalName: `ACRP/Optina Training Portal`
    , sponsorName: `Optina`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/Optina-logo-final.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'headlands': {
    helmet: `ACRP/Headlands Training Portal | ACRP Learning`
    , portalName: `ACRP/Headlands Training Portal`
    , sponsorName: `Headlands Research`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/jem_headlands_logo_alt.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'Langland': {
    helmet: `ACRP/Langland Training Portal | ACRP Learning`
    , portalName: `ACRP/Langland Training Portal`
    , sponsorName: `Langland`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/Langland-logo.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'mcaclinicaltrialacademy': {
    helmet: `ACRP/MCA Clinical Trial Academy | ACRP Learning`
    , portalName: `ACRP/MCA Clinical Trial Academy`
    , sponsorName: `MCA`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/MCA_foundation_logo_horizontal.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'Abiomed': {
    helmet: `ACRP/Abiomed Training Portal | ACRP Learning`
    , portalName: `ACRP/Abiomed Training Portal`
    , sponsorName: `Abiomed`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/AbioLogo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'TidalHealthClinicalResearch': {
    helmet: `ACRP/Tidal Health Clinical Research Training Portal | ACRP Learning`
    , portalName: `ACRP/Tidal Health Clinical Research Training Portal`
    , sponsorName: `Tidal Health`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/TidalHealth-logo.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'UFCTSI_CRPC': {
    helmet: `UFCTSI/CRPC Professional Development | ACRP Learning`
    , portalName: `UFCTSI/CRPC Professional Development`
    , sponsorName: `UFL`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/CRPC-logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'BHSF': {
    helmet: `ACRP/Baptist Health Training Portal | ACRP Learning`
    , portalName: `ACRP/Baptist Health Training Portal`
    , sponsorName: `Baptist Health`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/BHSF-Logo.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'TRIO': {
    helmet: `ACRP/Trio Training Portal | ACRP Learning`
    , portalName: `ACRP/Trio Training Portal`
    , sponsorName: `Tri-Oncology`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/trio-logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'VCU': {
    helmet: `ACRP/VCU Training Portal | ACRP Learning`
    , portalName: `ACRP/VCU Training Portal`
    , sponsorName: `VCU`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/vcu-logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'LSUHS': {
    helmet: `ACRP/LSUHS Training Portal | ACRP Learning`
    , portalName: `ACRP/LSUHS Training Portal`
    , sponsorName: `LSU`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/LSUHS_Horz__Purple-Gold_RGB.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'GadolinResearch': {
    helmet: `ACRP/Gadolin Training Portal | ACRP Learning`
    , portalName: `ACRP/Gadolin Training Portal`
    , sponsorName: `Gadolin Research`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/Gadolin-Logo.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'Greater_New_England_Chapter_ACRP': {
    helmet: `ACRP/Greater New England Chapter Training Portal | ACRP Learning`
    , portalName: `ACRP/Greater New England Chapter Training Portal`
    , sponsorName: `ACRP/Greater New England Chapter`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/NewEngland_Blue.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'Viracta': {
    helmet: `ACRP/Viracta Training Portal | ACRP Learning`
    , portalName: `ACRP/Viracta Training Portal`
    , sponsorName: `Viracta`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/Viracta_Logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'IMAResearch': {
    helmet: `ACRP/IMAResearch Training Portal | ACRP Learning`
    , portalName: `ACRP/IMAResearch Training Portal`
    , sponsorName: `IMAResearch`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/IMA_CR_Logo_2021.jpg`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'Lightship': {
    helmet: `ACRP/Lightship Training Portal | ACRP Learning`
    , portalName: `ACRP/Lightship Training Portal`
    , sponsorName: `Lightship`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/Lightship_Logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'AMCRInstitute': {
    helmet: `ACRP/AMCR Institute Training Portal | ACRP Learning`
    , portalName: `ACRP/AMCR Institute Training Portal`
    , sponsorName: `AMCR`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/AMCRI_Logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'Multicare': {
    helmet: `ACRP/Multicare Training Portal | ACRP Learning`
    , portalName: `ACRP/Multicare Training Portal`
    , sponsorName: `Multicare`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/MIRI_Logo_Blue.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'CRSSites': {
    helmet: `ACRP/CRSSites Training Portal | ACRP Learning`
    , portalName: `ACRP/CRSSites Training Portal`
    , sponsorName: `CRSSites`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/CRS_LOGO.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'MH-CTO': {
    helmet: `ACRP/MH-CTO Training Portal | ACRP Learning`
    , portalName: `ACRP/MH-CTO Training Portal`
    , sponsorName: `MMCRI`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/MMCRI_Logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'CancerConsortium': {
    helmet: `ACRP/CANCER CONSORTIUM Training Portal | ACRP Learning`
    , portalName: `ACRP/CANCER CONSORTIUM Training Portal`
    , sponsorName: `CANCER CONSORTIUM`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/CANCER_CONSORTIUM.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }
  
  // testing out new sso-specific landing pages, try to use existing format
  , 'UPenn': {
    helmet: `University of Pennsylvania`
    , portalName: `UPenn`
    , sponsorName: `University of Pennsylvania`
    , sponsorLogoUrl: `https://branding.web-resources.upenn.edu/sites/default/files/styles/card_3x2/public/2022-03/UniversityofPennsylvania_FullLogo_RGB-4_0.png`
    // , thirdPartyName: `The Association of Clinical Research Professionals`
    // , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
    , thirdPartyLoginText: 'Login Using Your Pennkey Credentials'
    , thirdPartyProvider: 'upenn'
    // , thirdPartyProvider: 'dev-test' // testing, upenn doesn't work

  }

  , 'Ascentage': {
    helmet: `ACRP/Ascentage Training Portal | ACRP Learning`
    , portalName: `ACRP/Ascentage Training Portal`
    , sponsorName: `Ascentage `
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/Ascentage_Pharma_logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'Parlexel': {
    helmet: `Parexel Training Portal| ACRP Learning`
    , portalName: `ACRP/Parexel Training Portal`
    , sponsorName: `Parlexel`
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/Parexel_Academy.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

  , 'AscentageELKA': {
    helmet: `ACRP/Ascentage Training Portal | ACRP Learning/ACRP/Ascentage Training Portal`
    , portalName: `ACRP/Ascentage ELKA Portal`
    , sponsorName: `Ascentage `
    , sponsorLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/Ascentage_Pharma_logo.png`
    , thirdPartyName: `The Association of Clinical Research Professionals`
    , thirdPartyLogoUrl: `https://pro-ficiency-static.s3.us-east-2.amazonaws.com/ACRP/B2B/acrp_logo.png`
  }

}

export default thirdPartyUtils;



// WEBPACK FOOTER //
// global/utils/thirdPartyUtils.js